import React from 'react'
import Typography from '@mui/material/Typography'
import { grey } from '../../../../colors'
import { Box } from '@mui/material'
import { ObjectListWrapper, ToolTipWrapper } from './styles'
import { Link } from 'react-router-dom'
import ROUTES from '../../../../consts/paths'
import { InsightTooltip, type OverflowClickHandler } from '../OverflowIndicator'

interface ObjectListItem {
  title?: string
  [key: string]: any
}
interface ObjectListProps {
  list: ObjectListItem[]
  disabled?: boolean
  onOverflowClick?: OverflowClickHandler
}

const ObjectList: React.FC<ObjectListProps> = ({ list = [], disabled = false, onOverflowClick }) => {
  const sortedList = React.useMemo(
    () => [...list].sort((a, b) => (a.title ?? '').localeCompare(b.title ?? '')),
    [list]
  )
  const overflowCount = Math.max(sortedList.length - 1, 0)
  const tooltipValues = sortedList.slice(1)

  const Title = (): JSX.Element => (
    <Box display="flex" gap={1} flexWrap="wrap">
      {tooltipValues?.map((item: ObjectListItem, index: number) => (
       <Link to={ROUTES.INSTRUCTOR_SURVEYS} key={`${item.title ?? ''}-${index}`}>
        <Typography fontWeight={600} color={grey[0]} fontSize="12px">
          {item?.title}
          {index !== tooltipValues.length - 1 && ','}
        </Typography>
       </Link>
      ))}
    </Box>
  )

  const displayedValue = sortedList[0]?.title

  return (
    <ObjectListWrapper color={grey[disabled ? 350 : 850]}>
      <Typography fontSize={'14px'}>
        {displayedValue}
      </Typography>
      {overflowCount > 0 && (
        <ToolTipWrapper onClick={onOverflowClick}>
          <InsightTooltip count={overflowCount} tooltipTitle={<Title />} onClick={onOverflowClick}>
            <Typography component="span" fontSize={14}>{`+${overflowCount}`}</Typography>
          </InsightTooltip>
        </ToolTipWrapper>
      )}
    </ObjectListWrapper>
  )
}

export default ObjectList
